/**
 * Error de la base. Una regla de negocio llega con `message` en español listo para
 * mostrar (codigo P0001); un permiso denegado, con 42501.
 */
export class ErrorDeBase extends Error {
  constructor(
    mensaje: string,
    readonly codigo?: string,
  ) {
    super(mensaje);
    this.name = 'ErrorDeBase';
  }

  get esSinPermiso(): boolean {
    return this.codigo === '42501';
  }

  get esNoAutenticado(): boolean {
    return this.message === 'No autenticado' || this.codigo === 'PGRST301';
  }
}

/** Texto para mostrar al usuario ante cualquier error capturado. */
export function mensajeDeError(error: unknown): string {
  if (error instanceof Error && error.message) return error.message;
  return 'La operación falló. Probá de nuevo.';
}
